import { useLang } from "../contexts/LanguageContext";
import { CONTACT } from "../i18n";

// Inline WhatsApp glyph so we don't depend on an icon update.
function WhatsAppIcon({ size = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M19.11 17.36c-.27-.13-1.6-.79-1.84-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.63 1.11 2.81.14.18 1.93 2.94 4.67 4.13.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.6-.65 1.83-1.27.23-.62.23-1.16.16-1.27-.07-.11-.25-.18-.52-.31zM16 4C9.37 4 4 9.37 4 16c0 2.13.56 4.13 1.55 5.86L4 28l6.32-1.66A11.93 11.93 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4zm0 22a9.93 9.93 0 0 1-5.06-1.38l-.36-.21-3.75.98 1-3.66-.24-.38A9.96 9.96 0 0 1 6 16c0-5.51 4.49-10 10-10s10 4.49 10 10-4.49 10-10 10z"
      />
    </svg>
  );
}

export default function WhatsAppButton({
  variant = "primary",
  size = "md",
  testId = "whatsapp-btn",
  className = "",
  prefilled = true,
}) {
  const { t, lang } = useLang();
  const number = CONTACT.whatsapp;
  const text =
    lang === "ar"
      ? "مرحبًا Wosol Tech، أرغب بالتواصل معكم بشأن خدماتكم."
      : "Hello Wosol Tech, I'd like to get in touch about your services.";
  const href = prefilled
    ? `https://wa.me/${number}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${number}`;

  const sizing =
    size === "sm"
      ? "px-4 py-2.5 text-[11px]"
      : size === "lg"
      ? "px-8 py-4 text-sm"
      : "px-5 py-3 text-xs";

  const styles =
    variant === "ghost"
      ? "border border-[#25D366]/40 text-[#25D366] hover:border-[#25D366] hover:bg-[rgba(37,211,102,0.08)] hover:shadow-[0_0_18px_rgba(37,211,102,0.35)]"
      : variant === "outline"
      ? "border border-[#00F0FF] text-[#00F0FF] hover:bg-[rgba(0,240,255,0.1)]"
      : "bg-[#25D366] text-[#0B1A0F] hover:bg-[#1ebe5a] hover:shadow-[0_0_22px_rgba(37,211,102,0.45)]";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label={t.nav.whatsapp}
      className={`inline-flex items-center gap-2 font-bold uppercase tracking-[0.16em] transition-all ${sizing} ${styles} ${className}`}
    >
      <WhatsAppIcon size={size === "lg" ? 20 : 16} />
      <span>{t.nav.whatsapp}</span>
    </a>
  );
}

export function WhatsAppIconOnly({ testId = "whatsapp-icon-btn", className = "" }) {
  const { t } = useLang();
  const number = CONTACT.whatsapp;
  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label={t.nav.whatsapp}
      title={t.nav.whatsapp}
      className={`relative inline-flex items-center justify-center w-11 h-11 border border-[#25D366]/40 text-[#25D366] hover:border-[#25D366] hover:bg-[rgba(37,211,102,0.08)] hover:shadow-[0_0_18px_rgba(37,211,102,0.4)] transition-all ${className}`}
    >
      <WhatsAppIcon size={18} />
    </a>
  );
}
